import { useEffect, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { fetchOnlineUsers } from '../../../services/superAdminService';

const SuperAdminOnlineUsersCard = () => {
  const { token } = useAuth();
  const [onlineCount, setOnlineCount] = useState(null);
  const [windowMinutes, setWindowMinutes] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatusMessage('Sign in to view online users.');
      return;
    }

    let isMounted = true;
    const refreshIntervalMs = 15000;

    const loadOnlineUsers = async () => {
      try {
        const payload = await fetchOnlineUsers(token);
        if (!isMounted) return;
        setOnlineCount(payload.count);
        setWindowMinutes(payload.windowMinutes);
        setStatusMessage('');
      } catch (error) {
        if (!isMounted) return;
        setStatusMessage(error.message || 'Unable to load online users.');
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        loadOnlineUsers();
      }
    };

    loadOnlineUsers();
    const interval = setInterval(loadOnlineUsers, refreshIntervalMs);
    window.addEventListener('focus', loadOnlineUsers);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      isMounted = false;
      clearInterval(interval);
      window.removeEventListener('focus', loadOnlineUsers);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [token]);

  return (
    <div className="border rounded p-3 d-grid gap-2 bg-light">
      <div>
        <p className="text-muted small mb-1">Online users</p>
        <p className="h3 mb-0">{onlineCount !== null ? onlineCount : '—'}</p>
      </div>
      <p className="text-muted small mb-0">
        {windowMinutes ? `Active in the last ${windowMinutes} minutes.` : 'Tracking recent activity.'}
      </p>
      {statusMessage && <p className="text-danger small mb-0">{statusMessage}</p>}
    </div>
  );
};

export default SuperAdminOnlineUsersCard;
